export const groupBy = (data, by) => {
    return data.reduce((acc, item) => {
        const key = item[by] || (item.latitude ? `${item.latitude}/${item.longitude}` : "Unknown"); // Usa "Unknown" para valores nulos
        if (!acc[key]) {
            acc[key] = [];
        }
        acc[key].push(item);
        return acc;
    }, {});
};